export const BULK_PIN_UPDATE_INIT_ACTION = "BULK_PIN_UPDATE_INIT_ACTION";
export const BULK_PIN_UPDATE_SUCCESS_ACTION = BULK_PIN_UPDATE_INIT_ACTION + "_SUCCESS";
export const BULK_PIN_UPDATE_FAIL_ACTION = BULK_PIN_UPDATE_INIT_ACTION + "_ERROR";

export const CLEAR_BULK_UPDATED_PIN_DATA_INIT_ACTION = 'CLEAR_BULK_UPDATED_PIN_DATA_INIT_ACTION';
